export function startResize({ e, current, min, max, onResize, invert = false }) {
  e.preventDefault();
  const startX = e.clientX;
  const startV = current;

  document.body.style.userSelect = 'none';
  document.body.style.cursor     = 'col-resize';

  function onMove(ev) {
    const delta = ev.clientX - startX;
    const next  = Math.min(max, Math.max(min, startV + (invert ? -delta : delta)));
    onResize(next);
  }

  function onUp() {
    document.body.style.userSelect = '';
    document.body.style.cursor     = '';
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup',   onUp);
  }

  document.addEventListener('mousemove', onMove);
  document.addEventListener('mouseup',   onUp);
}
